import React from "react";
import "./BlobOverlay.css";

const BlobOverlay = () => {
  return (
    <>
      <div className="background-container"></div>
      <div className="line-overlay-1"></div>
      <div className="line-overlay-2"></div>
      <div className="triangle"></div>
      <div className="word-container">
        <div className="word-1">Hola</div>
        <div className="word-2">नमस्ते</div>
        <div className="word-3">Bonjour</div>
        <div className="word-4">Ciao</div>
        <div className="word-5">Hej</div>
        <div className="word-6">哈囉</div>
        <div className="word-7">Jambo</div>
        <div className="word-8">حب</div>
        <div className="word-9">Olá</div>
        <div className="word-10">안녕하세요</div>
        <div className="word-11">Γειά σας</div>
        <div className="word-12">Hallo</div>
        <div className="word-13">שלום</div>
        <div className="word-14">สวัสดี</div>
        <div className="word-15">வணக்கம்</div>
        <div className="word-16">Cześć</div>
      </div>
    </>
  );
};

export default BlobOverlay;
